const theme = {
  textSecondary: "#36393f",
  background: "#fff",
};
export default theme;
